import { Component, OnInit } from '@angular/core';
import { DigitalAssetsModalComponent, mediaEmbed } from 'gung-standard';

@Component({
  selector: 'tylo-tylo-digital-assets-modal',
  templateUrl: './tylo-digital-assets-modal.component.html',
  styleUrls: ['./tylo-digital-assets-modal.component.css']
})
export class TyloDigitalAssetsModalComponent extends DigitalAssetsModalComponent implements OnInit{

  videosHtml=[];

  ngOnInit(): void {
    super.ngOnInit();
    for (const video of this.selectedDigitalAsset.extra?.links) {
        const html = mediaEmbed(video,'','100%','270px');
        this.videosHtml.push(html.embedHtml);
      
    }
  }
}
